import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppLoadingService } from './features/auth/services/app-loading.service';
import { LoadingComponent } from './shared/components/loading-component/loading.component';
import { AsyncPipe } from '@angular/common';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent, AsyncPipe],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private loading = inject(AppLoadingService);
  private readonly themeService = inject(ThemeService);
  loading$ = this.loading.loading$;

  constructor() {
    this.themeService.initializeFromStorage();
  }
}
